import type { ReactNode } from 'react';

/** Ported from src/components/ui/Glass.tsx — "things that float". */
export default function Glass({ children, className = '', radius, intensity }: {
  children?: ReactNode;
  className?: string;
  radius?: number;
  intensity?: number;
}) {
  return (
    <div
      className={`glass ${className}`.trim()}
      style={{
        borderRadius: radius ?? 'var(--radius-modal)',
        ...(intensity ? { backdropFilter: `blur(${intensity}px)`, WebkitBackdropFilter: `blur(${intensity}px)` } : {}),
      }}
    >
      {children}
    </div>
  );
}
